import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { ChatProvider } from "./context/ChatContext";
import { SocketProvider } from "./context/SocketContext";
import { ThreadProvider } from "./context/ThreadContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ChatProvider>
        <SocketProvider>
          <ThreadProvider>
            <App />
          </ThreadProvider>
        </SocketProvider>
      </ChatProvider>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
